<template>
    <section class="form-section">
        <form class="search-form" @submit="handleSubmit">
            <slot></slot>

            <div class="form-button-group">
                <NButton
                    type="primary"
                    size="large"
                    ghost
                    strong
                    :style="'background: #fff;'"
                    @click="initForm"
                    >초기화</NButton
                >
                <NButton attr-type="submit" type="primary" size="large" strong
                    >검색</NButton
                >
            </div>
        </form>
    </section>
</template>

<script setup lang="ts">
import {NButton} from 'naive-ui';

// props, emits, libs
const emits = defineEmits(['submit', 'initForm']);

// methods
const handleSubmit = (e: Event) => {
    e.preventDefault();
    emits('submit');
};

const initForm = () => {
    emits('initForm');
};
</script>

<style lang="scss" scoped>
.form-section {
    margin-bottom: 23px;
}

.search-form {
    padding: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 22px 32px;
    background-color: #f8f8fa;
    border-radius: 8px;

    :deep() {
        .form-input-group {
            display: flex;
            align-items: center;

            @media (max-width: 663px) {
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                flex: 0 100%;
            }

            .title {
                margin-right: 12px;
                color: $black_80;
                font-weight: bold;
                vertical-align: middle;

                @media (max-width: 663px) {
                    margin-bottom: 5px;
                }
            }

            .form-input-select {
                display: inline-flex;
                gap: 6px;

                @media (max-width: 566px) {
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    .selectbox-wrap,
                    select,
                    input,
                    .base-input-wrap,
                    .date-range-picker,
                    .selected-dates {
                        width: 100% !important;
                    }
                }
            }
        }
    }

    .form-button-group {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        flex: 1 100%;
        gap: 0 6px;
    }
}
</style>
